import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=22770ed8&"
import script from "./Background.vue?vue&type=script&lang=ts&"
export * from "./Background.vue?vue&type=script&lang=ts&"
import style0 from "./Background.vue?vue&type=style&index=0&id=22770ed8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports